import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { Button } from "@curves/ui-base";
import { EmployeeSelect } from "@icoach/components/";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import useCyclePurchaseApi from "@apis/useCyclePurchaseApi";
import useCyclePurchaseEffectApi from "@apis/useCyclePurchaseEffectApi";

const CycleEffectOrderQuitDialog = ({ className, open, sourceData, onClose, refresh }) => {
	const { memberID, cycleOrderID, effectID } = sourceData || {};
	const { getCyclePurchaseOptionsApi } = useCyclePurchaseApi();
	const { deleteCyclePurchaseEffectOrderApi } = useCyclePurchaseEffectApi();
	const [resource, setResource] = useState({});

	const employeeRef = useRef(null);

	const doCyclePurchaseOptionsApi = async () => {
		let res = await getCyclePurchaseOptionsApi();
		if (res) {
			setResource(res);
		}
	};
	let doDeleteCyclePurchaseEffectOrderApi = async (effectID, employeeID) => {
		let res = await deleteCyclePurchaseEffectOrderApi(effectID, employeeID);
		if (res) {
			refresh && refresh(memberID, cycleOrderID);
			onClose();
		}
	};

	const handleSubmit = () => {
		let isError = employeeRef.current && employeeRef.current.isError && employeeRef.current.isError();
		if (!isError) {
			const employeeID = employeeRef.current && employeeRef.current.getResult && employeeRef.current.getResult();
			doDeleteCyclePurchaseEffectOrderApi(effectID, employeeID);
		}
	};

	useEffect(
		() => {
			if (open) {
				doCyclePurchaseOptionsApi();
			}
		},
		// eslint-disable-next-line
		[open],
	);

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>刪除健康產品變更單</GradientColorHeader>
			<DialogContent>
				<Grid spacing={2} container>
					<Grid xs={12} item>
						<EmployeeSelect label="擔當" ref={employeeRef} options={resource?.coachOptions || []} fullWidth required />
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleSubmit} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CycleEffectOrderQuitDialog;
